import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { CheckExclusiveLic } from 'src/app/pipes/check-exclusive/check-exclusive-exist.pipe';
import { CommonService } from 'src/app/services/Common-function/common.service';
import { FormsService } from 'src/app/services/Forms/forms.service';
import { NegotiationService } from 'src/app/services/negotiation/negotiation.service';

@Component({
  selector: 'ipm-negotiation-pops',
  templateUrl: './negotiation-pops.component.html',
  styleUrls: ['./negotiation-pops.component.scss']
})
export class NegotiationPopsComponent implements OnInit {
  @Input() state: any = "";
  @Input() currentNegotiation: any = "";
  offerList: Array<any> = [];
  creditsOption: Array<string> = ["Yes", "No"];
  currentLicDetails: any = "";
  currentNegotiationDetails: any = "";
  @Output() counterEvent: EventEmitter<any> = new EventEmitter();
  @Output() backButtonEvent: EventEmitter<any> = new EventEmitter();
  
  constructor(private commonService: CommonService,
    private negotiationService: NegotiationService,
    public formService: FormsService,
    private router: Router) {
  }

  ngOnInit(): void {
    this.getOfferList();
  }


  /**
   * get current offer list
   */
  getOfferList() {
    this.offerList = JSON.parse(JSON.stringify(this.currentNegotiation.currentOfferDetails.OfferDetails));
  }


  /**
   * close Current Dialog box function
   */
  closePopup() {
    this.commonService.closePopUp();
  }

  /**
   * In this function action 
   * perform accepted and counter offer 
   * according to action type set boolean true or false
   * @param currentIndex 
   * @param actionType 
   */
  actionPerform(currentIndex: number, actionType: string) {
    if (actionType === 'accept') {
      this.offerList[currentIndex].isAccepted = true;
      this.offerList[currentIndex].isCounterEnable = false;
    } else if (actionType === 'undo') {
      this.offerList[currentIndex].isAccepted = false;
      this.offerList[currentIndex].isCounterEnable = false;
    } else{
      this.offerList[currentIndex].isAccepted = false;
      this.offerList[currentIndex].isCounterEnable = true;
    }
  }

  /**
   * In this function
   * Create negotiation Offer and 
   * Make a counter api call
   */
  makeOfferIOrCounter() {
    let sendObject: any = this.negotiationService.getBodyApiData(this.offerList);
    let isFormValid =  this.offerList.every(item => item.isValid === true);
    let isAllAccepted =  this.offerList.every(item => item.isAccepted === true);
    let previousOfferValue = this.negotiationService.getBodyApiData(this.offerList, 'previous');
    if ((typeof(sendObject?.price) === 'string'  && !sendObject?.price)  || 
        (typeof(sendObject?.price) === 'string'  && !sendObject?.publishingPercentage)) {
      this.commonService.showToastErrorMessage("Please provide some input");
    } else if (sendObject?.price === 0  || (sendObject?.price < this.offerList[0].currentOffer?.value * 0.1)) {
      this.commonService.showToastErrorMessage("The license fee must be a minimum of 10% of the original offer.");
    } else if (sendObject?.price === previousOfferValue?.price && 
      sendObject?.publishingPercentage === previousOfferValue?.publishingPercentage && !isAllAccepted) {
      this.commonService.showToastErrorMessage("The countered offer must differ from the previous offer");
    } else {
      if (this.state === "start") {
       if (isFormValid) {
         sendObject['beatSerialNumber'] = this.currentNegotiation.beatDetails.serial_number;
         this.negotiationService.createNegotiation(sendObject).subscribe((response) => { 
           this.closePopup();
           this.commonService.showToastSuccess("Successfully created Negotiation");
           this.negotiationService.addQueryParamsNegotiation(response.negotiationId, "b");
         }, (error) => {
           this.closePopup();
           this.commonService.showToastError(error);
         });
       }
      } else { 
       let isNotAcceptedOffer = this.offerList.every(item => item.isAccepted === false &&  item.isCounterEnable === false && item.label_Name !== 'Master Rights');
       let pendingToAccept = this.offerList.some(item => item.isAccepted === false && item.isCounterEnable ===  false && item.label_Name !== 'Master Rights');
       if (isNotAcceptedOffer) {
         this.commonService.showToastErrorMessage("Accept or counter the offer!");
       } else if (pendingToAccept) {
         this.commonService.showToastErrorMessage("Accept or counter the remaining terms!");
       } else {
          if (isFormValid) {
           this.negotiationService.makeCounterOffer(sendObject, this.currentNegotiation.negotiationId).subscribe((response) => { 
             this.closePopup();
             this.currentNegotiation.currentOfferDetails.OfferDetails =  this.offerList;
             this.counterEvent.emit(this.currentNegotiation);
           }, (error) => {
             this.closePopup();
             this.commonService.showToastError(error);
           });
          }
       }
      }
    }
  }

  /**
   * In this method checking Form Validation
   * @param $event 
   * @param currentIndex 
   */
  onInputBlur($event: any, currentIndex: number) {
    let currentOfferObject: any = this.offerList[currentIndex];
    let enterAmount = +currentOfferObject.formModel;
    if (!currentOfferObject.formModel && currentOfferObject.symbolType === 'price') {
      currentOfferObject.isValid = false;
      this.commonService.showToastErrorMessage(`The license fee must be a minimum of 10% of the original offer.`);
    } else if (!currentOfferObject.formModel && currentOfferObject.symbolType !== 'price') {
      currentOfferObject.isValid = false;
      this.commonService.showToastErrorMessage(`counter the remaining terms!`);
    } else {
      if (enterAmount < currentOfferObject.currentOffer?.value * 0.1 &&  currentOfferObject.symbolType === 'price') {
        currentOfferObject.isValid = false;
        this.commonService.showToastErrorMessage(`The license fee must be a minimum of 10% of the original offer.`);
      } else if (enterAmount > 50 && currentOfferObject.symbolType === 'percentage') {
        currentOfferObject.isValid = false;
        this.commonService.showToastErrorMessage(`The percentage must not exceed 50%`);
      } else {
        currentOfferObject.isValid = true;
      }
      this.offerList[currentIndex] = currentOfferObject;
    }
  }

  onClickBackButton() {
    this.closePopup();
    this.backButtonEvent.emit(this.currentNegotiation);
  }
}
